import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDarkMode = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" })
});
export default SvgDarkMode;
